// extracted by mini-css-extract-plugin
module.exports = {"dataContainer":"styles_dataContainer__3DyAE","comparisonCheckbox":"styles_comparisonCheckbox__29T7U"};